import { Component, computed, input, output, signal } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { CheckboxComponent } from '@valk-nx/components/ui-checkbox/src/lib/checkbox';

import type { FiltersItemInterface } from '../../contracts/filters.interface';

@Component({
	selector: `vp-filter-checkbox-group`,
	templateUrl: './filter-checkbox-group.html',
	host: { class: 'contents' },
	imports: [CheckboxComponent, TranslatePipe],
})
export class FilterCheckboxGroupComponent {
	title = input.required<string>();
	items = input<FiltersItemInterface[]>([]);
	itemsLimit = input.required<number>();
	activeValues = input<string[]>([]);

	changed = output<string[]>();

	protected readonly expanded = signal(false);

	protected readonly visibleItems = computed<FiltersItemInterface[]>(() =>
		this.expanded()
			? this.items()
			: this.items().slice(0, this.itemsLimit()),
	);

	protected readonly hasMoreItems = computed<boolean>(
		() => !this.expanded() && this.items().length > this.itemsLimit(),
	);

	showMore(): void {
		this.expanded.set(true);
	}

	onToggle(value: string, keep: boolean): void {
		const activeValues = this.activeValues();

		this.changed.emit(
			keep
				? [...new Set([...activeValues, value])]
				: activeValues.filter((activeValue) => activeValue !== value),
		);
	}
}
